var N;
(function(_) {
  _.Boolean = "Boolean", _.Float = "Float", _.ID = "ID", _.Integer = "Integer", _.String = "String", _.ListBoolean = "ListBoolean", _.ListFloat = "ListFloat", _.ListId = "ListId", _.ListInteger = "ListInteger", _.ListString = "ListString", _.Email = "Email", _.IpAddress = "IpAddress", _.Json = "Json", _.Phone = "Phone", _.Url = "Url", _.Date = "Date", _.DateTime = "DateTime", _.Time = "Time", _.Timestamp = "Timestamp";
})(N || (N = {}));
var I;
(function(_) {
  _.AWS_API_KEY = "aws_api_key", _.AWS_COGNITO_USER_POOLS = "aws_cognito_user_pools", _.AWS_IAM = "aws_iam", _.AWS_OIDC = "aws_oidc";
})(I || (I = {}));
var s;
(function(_) {
  _.Queries = "Queries", _.Mutations = "Mutations", _.Subscriptions = "Subscriptions";
})(s || (s = {}));
var E;
(function(_) {
  _.CREATE = "CREATE", _.BATCH_CREATE = "BATCH_CREATE", _.UPDATE = "UPDATE", _.DELETE = "DELETE", _.BATCH_DELETE = "BATCH_DELETE", _.EVENT = "EVENT", _.S3OBJECT = "S3OBJECT", _.INLINE_S3OBJECT = "INLINE_S3OBJECT", _.FILE = "FILE", _.INLINE_FILE = "INLINE_FILE", _.NONE = "NONE";
})(E || (E = {}));
var O;
(function(_) {
  _.BATCH = "BATCH", _.OBJECT = "OBJECT", _.LIST = "LIST", _.LIST_BY_PARENT = "LIST_BY_PARENT", _.CONNECTION = "CONNECTION", _.NONE = "NONE_QUERY";
})(O || (O = {}));
var S;
(function(_) {
  _.AFTER = "AFTER", _.BEFORE = "BEFORE", _.MAIN = "MAIN";
})(S || (S = {}));
var L;
(function(_) {
  _.ASSET = "ASSET", _.S3BUCKET = "S3BUCKET";
})(L || (L = {}));
var A;
(function(_) {
  _.NODEJS_22_X = "NODEJS_22_X", _.NODEJS_18_X = "NODEJS_18_X", _.PYTHON_3_10 = "PYTHON_3_10", _.GO_1_X = "GO_1_X", _.RUBY_2_7 = "RUBY_2_7", _.RUBY_3_2 = "RUBY_3_2", _.DOCKER = "DOCKER";
})(A || (A = {}));
var B;
(function(_) {
  _.Prod = "378858734076", _.Dev = "552331413797";
})(B || (B = {}));
export {
  N as F
};
